import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  AuthService,
  ClientService,
  UserService
} from 'app/shared/services';
import { Constants } from 'app/shared/config/constants';
import { isShowInIframeModeEnabled } from 'app/shared/lib';
import { Subscription } from 'rxjs';

@Component ( {
  selector: 'reporter-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: [ './user-menu.component.scss' ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
} )
export class UserMenuComponent implements OnInit, OnDestroy {

  @Output () logout = new EventEmitter ();
  @Output () loginAdmin = new EventEmitter ();
  @Input () disableClientChange;

  title = '';
  isWarningModalOpen = false;
  selectedClient;
  showClientsDialog = false;
  private loginChangedSubscription: Subscription;

  constructor (
    private userService: UserService,
    private clientService: ClientService,
    private authService: AuthService,
  ) {

  }

  ngOnInit (): void {
    this.syncClientDialogVisibility ();

    this.loginChangedSubscription = this.authService.loginChanged
      .subscribe ( ( res ) => {
        if ( !res ) {
          this.showClientsDialog = false;
          return;
        }

        this.syncClientDialogVisibility ();
      } );
  }

  ngOnDestroy (): void {
    this.loginChangedSubscription?.unsubscribe ();
  }

  get currentUser () {
    return this.userService.currentUser;
  }

  get currentClient (): any {
    return this.userService.currentClient;
  }

  get clients () {
    return this.userService.userClients;
  }

  async selectClient ( client: any ) {
    this.userService.currentClient = client;
    await this.clientService.getBUSettings ();
    this.reporterClientSelected = true;
    this.reloadWindow ();
  }

  async selectTempClient ( client: any ) {
    this.showClientsDialog = false;
    if ( !client?.clientNumber ) {
      return;
    }
    await this.userService.addTempClient ( client );
    this.selectedClient = client;
    this.isWarningModalOpen = true;
  }

  reloadWindow (): void {
    window.location.reload ();
  }

  openWarningModal ( client ) {
    this.isWarningModalOpen = true;
    this.selectedClient = client;
  }

  get isAdminUser () {
    return this.userService.userHasPermission ( 'ADMIN_USER' );
  }

  get isLimitedAdminUser () {
    return this.userService.userHasPermission ( 'LIMITED_ADMIN' );
  }

  openAdmin () {
    if ( this.isAdminUser || this.isLimitedAdminUser ) {
      this.loginAdmin.emit ();
    }
  }

  openClientsDialog () {
    this.showClientsDialog = true;
  }

  get isSystemUser () {
    return this.userService.isSystemUser;
  }

  get reporterClientSelected () {
    return !this.authService.isAuthenticated ||
      this.isSystemUser ||
      localStorage.getItem ( Constants.localStorageKeys.reporterClientSelected );
  }

  set reporterClientSelected ( value ) {
    if ( !this.isSystemUser && value ) {
      localStorage.setItem ( Constants.localStorageKeys.reporterClientSelected, '1' );
    } else {
      localStorage.removeItem ( Constants.localStorageKeys.reporterClientSelected );
    }
  }

  dismissWarningModal () {
    this.isWarningModalOpen = false;
    this.selectedClient = null;
    if ( !this.reporterClientSelected ) {
      this.openClientsDialog ();
    }
  }

  private syncClientDialogVisibility (): void {
    if ( this.authService.isAuthenticated && this.clients.length === 1 && !this.isSystemUser ) {
      this.reporterClientSelected = true;
    }

    this.showClientsDialog = this.shouldShowClientsDialog ();
  }

  private shouldShowClientsDialog (): boolean {
    return this.authService.isAuthenticated &&
      this.clients.length > 1 &&
      !this.isSystemUser &&
      !isShowInIframeModeEnabled ( undefined, location.search ) &&
      !this.reporterClientSelected;
  }
}
